import { languageNameInterpolations } from '@lessonnine/pidgin.js';

import { LOCALE } from 'src/dataLayer/env';
import { getPidginLanguageName } from 'src/dataLayer/localData/languageCodes';
import { InterpolationVariables } from 'src/viewLayer/components/shared/TextWithInterpolation/types';

const LANGUAGE_INTERPOLATION_REGEX = /[^<]*<([^>]*)>/;
const COMPONENT_INTERPOLATION_REGEX = /<[^>]+>/;
const VARIABLE_INTERPOLATION_REGEX = /\${([^}]*)}/g;

const getTranslatedLearnLang = (translationText: string, learnLang: string): string => {
  const locale = LOCALE;
  const languageNameFromTranslation = translationText.match(LANGUAGE_INTERPOLATION_REGEX);
  const pidginLanguageName = languageNameFromTranslation ? languageNameFromTranslation[1] : '';
  const languageName = pidginLanguageName || getPidginLanguageName(locale);
  return languageNameInterpolations({ locale, learnLanguageAlpha3: learnLang })[languageName];
};

// this function can be used to interpolate the language before styling the text
// the export can be removed once TextWithInterpolation has been adapted to work directly with getTextWithInterpolation
export const getTextWithLearnLangInterpolation = (translationText: string, learnLang: string): string => {
  const splitter = COMPONENT_INTERPOLATION_REGEX;
  const [part1, part2] = translationText.split(splitter);
  const translatedLearnLang = getTranslatedLearnLang(translationText, learnLang);

  return splitter.test(translationText) ?
    `${part1}${translatedLearnLang}${part2}` :
    translationText;
};

/* Interpolates a given string with the given variables eg.

   INPUT
   text: 'popty ${noun} - such a %{adjective} team!'
   variables: {
     noun: 'people',
     adjective: 'great'
   }

   OUTPUT
   'popty people - such a great team!'

   We cannot use template literals, since the translation coming from wti is not a template literal, so we have to
   manually interpolate values.
*/
const interpolate = (text: string, variables: InterpolationVariables): string => {
  let copyOfText = text;
  const variablesToReplace = text.matchAll(VARIABLE_INTERPOLATION_REGEX);
  for (const match of variablesToReplace) {
    if (variables[match[1]]) {
      copyOfText = copyOfText.replace(match[0], String(variables[match[1]]));
    }
  }
  return copyOfText;
};

export const getTextWithInterpolation = (text: string, variables: InterpolationVariables = {}): string => {
  let result = text;
  if (variables.learnLang) { result = getTextWithLearnLangInterpolation(text, variables.learnLang); }
  return interpolate(result, variables);
};
